import Vue from "vue";
import Router from "vue-router";

// const originalPush = Router.prototype.push;

// Router.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject)
//     return originalPush.call(this, location, onResolve, onReject);
//   return originalPush.call(this, location).catch(err => err);
// };

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import("./views/index.vue"),
      redirect: "/home",
      children: [
        {
          path: "/home",
          name: "home",
          component: () => import("./views/home/index.vue"),
          meta: {
            title: "订单筛选"
            // requireAuth: true //当有这个字段的时候，我们就认为他这个路由页面是要有登录权限的
          }
        },
        {
          path: "/bannerDetail/:id",
          name: "bannerDetail",
          component: () => import("./views/bannerDetail/index.vue"),
          meta: {
            title: "轮播详情"
          }
        },
        {
          path: "/squeeze",
          name: "squeeze",
          component: () => import("./views/orderDetails/squeezeUrl.vue"),
          meta: {
            title: "落地页"
          }
        },
        {
          path: "/orderConfirm",
          name: "orderConfirm",
          component: () => import("./views/orderConfirm/index.vue"),
          meta: {
            title: "订单确认"
          }
        },
        {
          path: "/confirmWeight",
          name: "confirmWeight",
          component: () =>
            import("./views/releaseOrderConfirm/confirmWeight.vue"),
          meta: {
            title: "确认订单权限"
          }
        },
        {
          path: "/releaseOrderConfirm",
          name: "releaseOrderConfirm",
          component: () =>
            import("./views/releaseOrderConfirm/releaseOrderConfirm.vue"),
          meta: {
            title: "发布订单确认"
          }
        },
        {
          path: "/markSearch",
          name: "markSearch",
          component: () => import("./views/releaseOrderConfirm/markSearch.vue"),
          meta: {
            title: "联想搜索框"
          }
        },
        {
          path: "/suppCenterNew",
          name: "suppCenterNew",
          component: () => import("./views/suppCenter/suppCenter.vue"),
          meta: {
            title: "供应商个人中心"
          }
        },
        {
          path: "/basicInfo",
          name: "basicInfo",
          component: () => import("./views/suppCenter/basicInfo.vue"),
          meta: {
            title: "企业基本信息"
          }
        },
        {
          path: "/suppEnterprise",
          name: "suppEnterprise",
          component: () => import("./views/suppCenter/suppEnterprise.vue"),
          meta: {
            title: "企业规模"
          }
        },
        {
          path: "/suppQualification",
          name: "suppQualification",
          component: () => import("./views/suppCenter/suppQualification.vue"),
          meta: {
            title: "企业资质"
          }
        },
        {
          path: "/suppSuccess",
          name: "suppSuccess",
          component: () => import("./views/suppCenter/suppSuccess.vue"),
          meta: {
            title: "企业信息保存成功"
          }
        },
        {
          path: "/increaseWeChat",
          name: "increaseWeChat",
          component: () => import("./views/suppCenter/increaseWeChat.vue"),
          meta: {
            title: "增加微信"
          }
        },
        {
          path: "/deposit",
          name: "deposit",
          component: () => import("./views/deposit/deposit.vue"),
          meta: {
            title: "提现红包"
          }
        },
        {
          path: "/depositSucc",
          name: "depositSucc",
          component: () => import("./views/deposit/depositSucc.vue"),
          meta: {
            title: "提现成功"
          }
        },
        // {
        //   path: "/search",
        //   name: "search",
        //   component: () =>
        //     import(/* webpackChunkName: "search" */ "./views/search/index.vue")
        // },
        // {
        //   path: "/shopCart",
        //   name: "shopCart",
        //   meta: {
        //     requireAuth: true //当有这个字段的时候，我们就认为他这个路由页面是要有登录权限的
        //   },
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "shopCart" */ "./views/shopCart/index.vue"
        //     )
        // },
        // {
        //   path: "/mine",
        //   name: "mine",
        //   meta: {
        //     requireAuth: true //当有这个字段的时候，我们就认为他这个路由页面是要有登录权限的
        //   },
        //   component: () =>
        //     import(/* webpackChunkName: "mine" */ "./views/mine/index.vue")
        // },
        // 隐私政策
        {
          path: "/privacy",
          name: "privacy",
          component: () => import("./views/privacyPolicy/privacy.vue"),
          meta: {
            title: "隐私政策"
          }
        },
        // 使用条款
        {
          path: "/termsUse",
          name: "termsUse",
          component: () => import("./views/privacyPolicy/termsUse.vue"),
          meta: {
            title: "使用条款"
          }
        },
        // 订单协议
        {
          path: "/orderAgreement",
          name: "orderAgreement",
          component: () => import("./views/privacyPolicy/orderAgreement.vue"),
          meta: {
            title: "订单协议"
          }
        },
        // 成功提示
        {
          path: "/tipSucc",
          name: "tipSucc",
          component: () => import("./views/privacyPolicy/tipSucc.vue"),
          meta: {
            title: "成功提示"
          }
        },
        // 订单详情
        {
          path: "/orderDetails",
          name: "orderDetails",
          component: () => import("./views/orderDetails/orderDetails.vue"),
          meta: {
            title: "订单详情"
          }
        },
        // 报名
        {
          path: "/orderDetailsCopy",
          name: "orderDetailsCopy",
          component: () => import("./views/orderDetails/orderDetailsCopy.vue"),
          meta: {
            title: "报名"
          }
        },
        // 采购商报名
        {
          path: "/Statistics",
          name: "Statistics",
          component: () => import("./views/orderDetails/Statistics.vue"),
          meta: {
            title: "报名"
          }
        },
        {
          path: "/landingPage",
          name: "landingPage",
          component: () => import("./views/orderDetails/landingPage.vue"),
          meta: {
            title: "订单详情"
          }
        },
        // 联系方式
        {
          path: "/contact",
          name: "contact",
          component: () => import("./views/orderDetails/contact.vue"),
          meta: {
            title: "联系方式"
          }
        },
        {
          path: "/offer",
          name: "offer",
          component: () => import("./views/offer/index.vue"),
          meta: {
            title: "报价列表"
          }
        },
        {
          path: "/offerCopy",
          name: "offerCopy",
          component: () => import("./views/offerCopy/index.vue"),
          meta: {
            title: "报价列表"
          }
        },
        {
          path: "/addressList",
          name: "addressList",
          component: () => import("./views/address/addressList.vue"),
          meta: {
            title: "地址列表"
          }
        },
        // /:addId
        {
          path: "/addressEdit",
          name: "addressEdit",
          component: () => import("./views/address/addressEdit.vue"),
          meta: {
            title: "地址详情"
          }
        },
        {
          path: "/casting",
          name: "casting",
          component: () => import("./views/casting/index.vue"),
          meta: {
            title: "铸件搜索"
          }
        },
        {
          path: "/sms/index",
          name: "SmsIndex",
          component: () => import("./views/sms/index.vue"),
          meta: {
            title: "报名"
          }
        },
        {
          path: "/sms/second",
          name: "SmsSecond",
          component: () => import("./views/sms/second.vue"),
          meta: {
            title: "报名"
          }
        },
        {
          path: "/sms/third",
          name: "SmsThird",
          component: () => import("./views/sms/third.vue"),
          meta: {
            title: "报名"
          }
        },
        {
          path: "/sms/four",
          name: "SmsFour",
          component: () => import("./views/sms/four.vue"),
          meta: {
            title: "报名"
          }
        },
        {
          path: "/sms/fifth",
          name: "SmsFifth",
          component: () => import("./views/sms/fifth.vue"),
          meta: {
            title: "报名"
          }
        },
        {
          path: "/sms/sixth",
          name: "SmsSixth",
          component: () => import("./views/sms/sixth.vue"),
          meta: {
            title: "铸采购"
          }
        },
        {
          path: "/mobileShop/index",
          name: "Shop",
          component: () => import("./views/mobileShop/index.vue"),
          meta: {
            title: "跳转店铺"
          }
        },
        {
          path: "/sms/seventh",
          name: "SmsSeventh",
          component: () => import("./views/sms/seventh.vue"),
          meta: {
            title: "原材料设备厂落地页"
          }
        },
        {
          path: "/sms/eighth",
          name: "SmsEighth",
          component: () => import("./views/sms/eighth.vue"),
          meta: {
            title: "原材料设备厂落地页"
          }
        },
        {
          path: "/sms/ninth",
          name: "ninth",
          component: () => import("./views/sms/ninth.vue"),
          meta: {
            title: "原材料设备厂落地页"
          }
        },
        {
          path: "/sms/eleventh",
          name: "eleventh",
          component: () => import("./views/sms/eleventh.vue"),
          meta: {
            title: "原材料设备厂落地页"
          }
        },
        {
          path: "/sms/tenth",
          name: "tenth",
          component: () => import("./views/sms/tenth.vue"),
          meta: {
            title: "蓄电池落地页"
          }
        },
        {
          path: "/wechat/index",
          name: "WechatIndex",
          component: () => import("./views/wechat/index.vue"),
          meta: {
            title: "制作分享"
          }
        },
        {
          path: "/wechat/share",
          name: "WechatShare",
          component: () => import("./views/wechat/share.vue"),
          meta: {
            title: "用做分享"
          }
        },
        {
          path: "/wechat/auth",
          name: "WechatAuth",
          component: () => import("./views/wechat/auth.vue"),
          meta: {
            title: "授权"
          }
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/entry/Login.vue"),
      meta: {
        title: "登录"
      }
    },
    {
      path: "/logout",
      name: "logout",
      component: () => import("./views/entry/Logout.vue"),
      meta: {
        title: "退出"
      }
    },
    {
      path: "/register",
      name: "register",
      component: () => import("./views/entry/Register.vue"),
      meta: {
        title: "注册"
      }
    },
    {
      path: "/registers",
      name: "registers",
      component: () => import("./views/entry/Registers.vue"),
      meta: {
        title: "注册"
      }
    },
    {
      path: "/refresh",
      name: "refresh",
      component: () => import("./views/refresh/index.vue"),
      meta: {
        title: "网络异常"
      }
    },
    {
      path: "/searchLogin",
      name: "searchLogin",
      component: () => import("./views/searchSupp/searchLogin.vue"),
      meta: {
        title: "采购商登录"
      }
    },
    {
      path: "/searchIndex",
      name: "searchIndex",
      component: () => import("./views/searchSupp/searchIndex.vue"),
      meta: {
        title: "搜索列表"
      }
    },
    {
      path: "/searchList",
      name: "searchList",
      component: () => import("./views/searchSupp/searchList.vue"),
      meta: {
        title: "进行选项"
      }
    },
    {
      path: "/searchSuppList",
      name: "searchSuppList",
      component: () => import("./views/searchSupp/searchSuppList.vue"),
      meta: {
        title: "查询供应商"
      }
    },
    //客户登录确认
    {
      path: "/confirmLogin",
      name: "confirmLogin",
      component: () => import("./views/idConfirm/confirmLogin.vue"),
      meta: {
        title: "客户确认登陆"
      }
    },
    {
      path: "/choose",
      name: "choose",
      component: () => import("./views/idConfirm/choose.vue"),
      meta: {
        title: "是否"
      }
    },
    {
      path: "/success",
      name: "success",
      component: () => import("./views/idConfirm/success.vue"),
      meta: {
        title: "确认"
      }
    },
    {
      path: "/reject",
      name: "reject",
      component: () => import("./views/idConfirm/reject.vue"),
      meta: {
        title: "拒绝"
      }
    },
    {
      path: "/counterselection",
      name: "counterselection",
      component: () => import("./views/counterselection/index.vue"),
      meta: {
        title: "选择"
      }
    },
    {
      path: "/foundry",
      name: "foundry",
      component: () => import("./views/foundry/index.vue"),
      meta: {
        title: "铸造厂"
      }
    }
  ]
});

let arr = [
  "offer",
  "offerCopy",
  "contact",
  "suppCenterNew",
  "releaseOrderConfirm",
  "deposit",
  "confirmWeight"
];

router.beforeEach((to, from, next) => {
  if (!localStorage.token) {
    if (to.name == "logout") {
      next({ path: "/home" });
    }
    if (arr.indexOf(to.name) > -1) {
      sessionStorage.setItem("toName", to.name);
      sessionStorage.setItem("toQuery", JSON.stringify(to.query));
      if (to.name === "releaseOrderConfirm") {
        if (getCookie("token")) {
          localStorage.setItem("token", getCookie("token"));
          localStorage.setItem("userId", getCookie("userId"));
          localStorage.setItem("memType", getCookie("memType"));
          localStorage.setItem("receive", getCookie("receive"));
          next();
          return;
        } else {
          next({ path: "/login" });
        }
      }
      next({ path: "/login" });
    } else {
      next();
    }
  } else {
    next();
  }
  window.scroll(0, 0);
});

router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    window.location.reload();
  }
});

function getCookie(name) {
  var strcookie = document.cookie; //获取cookie字符串
  var arrcookie = strcookie.split("; "); //分割
  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split("=");
    if (arr[0] == name) {
      return arr[1];
    }
  }
  return "";
}

export default router;
